            package com.hyperether.resources
            
            import androidx.compose.runtime.Composable
            import androidx.compose.runtime.mutableStateOf
            import org.jetbrains.compose.resources.StringResource
            
            import com.hyperether.resources.StringsDefault
import com.hyperether.resources.StringsDe
            
            /**
             * Current language state for the application
             */
            val currentLanguage = mutableStateOf(AppLocale.DEFAULT)
            
            /**
             * Generated LocalizedStrings utility class
             */
            object LocalizedStrings {
                private val strings = mapOf(
                        AppLocale.DEFAULT to StringsDefault.strings,
        AppLocale.DE to StringsDe.strings
                )
                
                /**
                 * Get localized string by key and locale
                 * 
                 * @param key The string resource key
                 * @param locale The locale to use
                 * @return The localized string or fallback to default locale if missing
                 */
                fun get(key: String, locale: AppLocale): String {
                    return strings[locale]?.get(key) ?: strings[AppLocale.DEFAULT]?.get(key)
                        ?: "???"
                }
            }
            
            /**
             * Get localized string resource in composable context
             * 
             * @param key The string resource generated by Compose Multiplatform
             * @return The localized string for the current language
             */
            @Composable
            fun stringResource(key: StringResource): String {
                val locale = currentLanguage.value
                return LocalizedStrings.get(key.key, locale)
            }
            
            /**
             * Get localized string resource in non-composable context
             * 
             * @param key The string resource generated by Compose Multiplatform
             * @return The localized string for the current language
             */
            fun stringResourcePlain(key: StringResource): String {
                val locale = currentLanguage.value
                return LocalizedStrings.get(key.key, locale)
            }